export const PERFILES_GET_ROLES_BEGIN = 'PERFILES_GET_ROLES_BEGIN';
export const PERFILES_GET_ROLES_SUCCESS = 'PERFILES_GET_ROLES_SUCCESS';
export const PERFILES_GET_ROLES_FAILURE = 'PERFILES_GET_ROLES_FAILURE';
export const PERFILES_GET_ROLES_DISMISS_ERROR = 'PERFILES_GET_ROLES_DISMISS_ERROR';
export const PERFILES_GET_FUNCTIONS_MODULES_BEGIN = 'PERFILES_GET_FUNCTIONS_MODULES_BEGIN';
export const PERFILES_GET_FUNCTIONS_MODULES_SUCCESS = 'PERFILES_GET_FUNCTIONS_MODULES_SUCCESS';
export const PERFILES_GET_FUNCTIONS_MODULES_FAILURE = 'PERFILES_GET_FUNCTIONS_MODULES_FAILURE';
export const PERFILES_GET_FUNCTIONS_MODULES_DISMISS_ERROR = 'PERFILES_GET_FUNCTIONS_MODULES_DISMISS_ERROR';
export const PERFILES_CREATE_ROLE_BEGIN = 'PERFILES_CREATE_ROLE_BEGIN';
export const PERFILES_CREATE_ROLE_SUCCESS = 'PERFILES_CREATE_ROLE_SUCCESS';
export const PERFILES_CREATE_ROLE_FAILURE = 'PERFILES_CREATE_ROLE_FAILURE';
export const PERFILES_CREATE_ROLE_DISMISS_ERROR = 'PERFILES_CREATE_ROLE_DISMISS_ERROR';
export const PERFILES_GET_ROLE_BY_ID_BEGIN = 'PERFILES_GET_ROLE_BY_ID_BEGIN';
export const PERFILES_GET_ROLE_BY_ID_SUCCESS = 'PERFILES_GET_ROLE_BY_ID_SUCCESS';
export const PERFILES_GET_ROLE_BY_ID_FAILURE = 'PERFILES_GET_ROLE_BY_ID_FAILURE';
export const PERFILES_GET_ROLE_BY_ID_DISMISS_ERROR = 'PERFILES_GET_ROLE_BY_ID_DISMISS_ERROR';
export const PERFILES_UPDATE_ROLE_BEGIN = 'PERFILES_UPDATE_ROLE_BEGIN';
export const PERFILES_UPDATE_ROLE_SUCCESS = 'PERFILES_UPDATE_ROLE_SUCCESS';
export const PERFILES_UPDATE_ROLE_FAILURE = 'PERFILES_UPDATE_ROLE_FAILURE';
export const PERFILES_UPDATE_ROLE_DISMISS_ERROR = 'PERFILES_UPDATE_ROLE_DISMISS_ERROR';
export const PERFILES_DELETE_ROLE_BEGIN = 'PERFILES_DELETE_ROLE_BEGIN';
export const PERFILES_DELETE_ROLE_SUCCESS = 'PERFILES_DELETE_ROLE_SUCCESS';
export const PERFILES_DELETE_ROLE_FAILURE = 'PERFILES_DELETE_ROLE_FAILURE';
export const PERFILES_DELETE_ROLE_DISMISS_ERROR = 'PERFILES_DELETE_ROLE_DISMISS_ERROR';
export const PERFILES_SET_ROLE_ID_CLONED = 'PERFILES_SET_ROLE_ID_CLONED';
export const PERFILES_GET_TOOLS_BY_ROLE_BEGIN = 'PERFILES_GET_TOOLS_BY_ROLE_BEGIN';
export const PERFILES_GET_TOOLS_BY_ROLE_SUCCESS = 'PERFILES_GET_TOOLS_BY_ROLE_SUCCESS';
export const PERFILES_GET_TOOLS_BY_ROLE_FAILURE = 'PERFILES_GET_TOOLS_BY_ROLE_FAILURE';
export const PERFILES_GET_TOOLS_BY_ROLE_DISMISS_ERROR = 'PERFILES_GET_TOOLS_BY_ROLE_DISMISS_ERROR';
